import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

// import GmapVue from 'gmap-vue'
// Vue.use(GmapVue, {
//   load: {
//     key: 'AIzaSyDDpGdq0Cm4KSk0U7wZBGzcutjZZ4xmi7A',
//   },
// })

import Gmaps from '@/plugins/gmaps'
Vue.use(Gmaps)

import VueWobCache from './vue-wob-cache/vue-wob-cache'
Vue.use(VueWobCache)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
